import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Multi-tag input backed by TomSelect. Used for free-form keyword/tag fields
// where admins type new values and press Enter to add them as chips.
export default class extends Controller {
  static values = {
    placeholder: { type: String, default: "" }
  }

  connect() {
    this.tomSelect = new TomSelect(this.element, {
      create: true,
      persist: true,
      plugins: ["remove_button"],
      placeholder: this.placeholderValue,
      delimiter: null
    })
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
